import React from 'react';
import TabbedPage from '../../../../Elements/TabbedPage';
import OverWindow from '../../../../Elements/TabList/OverWindow';
import PaymentExportDetailsPaymentExportsTab from '../../../Operations/PaymentExport/AllExport/PaymentExportDetailsPaymentExportsTab';
import PendingReviewTab from './PendingReviewTab';
import PendingApprovalTab from './PendingApprovalTab';
import PendingApprovalVatTab from './PendingApprovalVatTab';
import AllPaymentsTab from './AllPaymentsTab';

export default class ShowEvaluatorPaymentsOverDataWindow extends React.Component {
  static defaultProps = {
    evaluator: {},
    clickOnCancel: () => {
      alert('Missing function');
    },
  };

  tabs = [
    {
      label: 'Exported Payments',
      id: 'exportedpayments',
      icon: 'fa-solid fa-memo-circle-info',
      component: (
        <PaymentExportDetailsPaymentExportsTab
          evaluatorId={this.props.evaluator.EvId}
          ieStatusCode='1'
          showActionButtonRow={false}
        />
      ),
    },
    {
      label: 'Pending Approval',
      id: 'pendingapproval',
      icon: 'fa-solid fa-memo-circle-info',
      component: <PendingApprovalTab evaluatorId={this.props.evaluator.EvSassieId} />,
    },
    {
      label: 'Pending Review',
      id: 'pendingreview',
      icon: 'fa-solid fa-memo-circle-info',
      component: <PendingReviewTab evaluatorId={this.props.evaluator.EvSassieId} />,
    },
    {
      label: 'Pending Approval (VAT)',
      id: 'pendingapprovalvat',
      icon: 'fa-solid fa-memo-circle-info',
      component: <PendingApprovalVatTab evaluatorId={this.props.evaluator.EvSassieId} />,
    },
    {
      label: 'All Payments',
      id: 'allpayments',
      icon: 'fa-solid fa-memo-circle-info',
      component: <AllPaymentsTab evaluatorId={this.props.evaluator.EvSassieId} />,
    },
  ];

  getIdDisplay() {
    if (this.props.evaluator.EvSassieId === undefined) {
      return this.props.evaluator.AsCcuid !== undefined ? ` (Client ID: ${this.props.evaluator.AsCcuid})` : '';
    }
    return ` (SassieId: ${this.props.evaluator.EvSassieId})`;
  }

  getDisplayName() {
    if (this.props.evaluator.EvLastName === undefined && this.props.evaluator.EvFirstName === undefined) {
      return '';
    } else if (this.props.evaluator.EvLastName === undefined) {
      return ` - ${this.props.evaluator.EvFirstName}`;
    } else if (this.props.evaluator.EvFirstName === undefined) {
      return ` - ${this.props.evaluator.EvLastName}`;
    }
    return ` - ${this.props.evaluator.EvLastName}, ${this.props.evaluator.EvFirstName}`;
  }

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={`Evaluator Payments${this.getDisplayName()}${this.getIdDisplay()}`}
        closeOnClickOutside={false}
      >
        <div className='verticalScroll showassignmentlistheight'>
          <TabbedPage tabs={this.tabs} />
        </div>
      </OverWindow>
    );
  }
}